<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <b-tabs
      ref="tabs"
      v-model="search.year"
      pills
      class="mb-4"
      @input="getReportMemberExclusionPaycount()"
    >
      <b-tab
        v-for="(item, index) in options.year"
        :key="index"
        :title="item.label"
      />
    </b-tabs>

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
    ></tables-page>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import reportApi from "@/models/API/reportApi";
import TablesPage from "@/components/layouts/TablesPage";
import { handleNaN } from "@/models/HELPERS/common.js";

export default {
  name: 'memberExclusionPaycount',
  components: {
    BreadCrumb,
    TablesPage
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '報表', url: '', isActive: true },
          { name: '失效會員繳款次數', url: '', isActive: false }
        ]
      },
      options: {
        year: [],
      },
      search: {
        year: 0
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "count",
            label: "繳費次數",
          },
          {
            key: "A",
            label: "A組"
          },
          {
            key: "A_percentage",
            label: "%",
          },
          {
            key: "B",
            label: "B組"
          },
          {
            key: "B_percentage",
            label: "%",
          },
          {
            key: "C",
            label: "C組"
          },
          {
            key: "C_percentage",
            label: "%",
          },
          {
            key: "total_number",
            label: "失效總件數",
          },
          {
            key: "all_percentage",
            label: "%",
          },
        ]
      },
    }
  },
  computed: {

  },
  mounted() {
    this.reportApi = new reportApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.generateYearArray();
    },
    // 產生年份陣列資料
    generateYearArray() {
      const currentYear = new Date().getFullYear(); // Get current year in AD
      const startYearROC = 105; // Start year in ROC
      const endYearROC = currentYear - 1911; // End year in ROC

      const yearArray = Array.from({ length: currentYear - (startYearROC + 1911) + 1}, (num, index) => {
        const rocYear = endYearROC - index;
        const adYear = currentYear - index;

        return {
          value: index + 1,
          label: `${rocYear}年`,
          key: adYear,
        };
      });

      yearArray.unshift({
        value: 0,
        label: '全部',
        key: '',
      })

      this.options.year = yearArray;
      this.getReportMemberExclusionPaycount();
    },
    // 取得業務年齡層
    getReportMemberExclusionPaycount() {
      const year = this.options.year.find(item => item.value === this.search.year).key;
      const params = {
        year: year
      };

      this.reportApi.getReportMemberExclusionPaycount((response) => {
        const res = response.data;

        this.tableFormatHandler(res.data[0])
      }, params)
    },
    // 表格格式整理
    tableFormatHandler(data) {
      const table_classified_data = {
        count_0: { count: '0次', total_number: 0 },
        count_1_3: { count: '1-3次', total_number: 0 },
        count_4_10: { count: '4-10次', total_number: 0 },
        count_11_15: { count: '11-15次', total_number: 0 },
        count_16_20: { count: '16-20次', total_number: 0 },
        count_21_25: { count: '21-25次', total_number: 0 },
        count_26_30: { count: '26-30次', total_number: 0 },
        count_31_35: { count: '31-35次', total_number: 0 },
        count_36_40: { count: '36-40次', total_number: 0 },
        count_41_45: { count: '41-45次', total_number: 0 },
        count_46_50: { count: '46-50次', total_number: 0 },
        count_51: { count: '51次以上', total_number: 0 },
        count_total: { count: '總計', total_number: 0 },

      };

      Object.entries(table_classified_data).forEach(([table_key, table_value]) => {
        this.data.table_fields.forEach(item => {
          const current_key = `${table_key}_${item.key}`;

          const current_A_value = `${table_key}_A`;
          const current_B_value = `${table_key}_B`;
          const current_C_value = `${table_key}_C`;

          const current_total_A_value = data['count_total_A'];
          const current_total_B_value = data['count_total_B'];
          const current_total_C_value = data['count_total_C'];

          if (item.key === 'all_percentage') {
            table_classified_data[table_key][item.key] = `${handleNaN(table_classified_data[table_key].total_number / (current_total_A_value + current_total_B_value + current_total_C_value) * 100).toFixed(1)}%`
          } else if (item.key === 'A_percentage') {
            table_classified_data[table_key][item.key] = `${handleNaN(data[current_A_value] / current_total_A_value * 100).toFixed(1)}%`
          } else if (item.key === 'B_percentage') {
            table_classified_data[table_key][item.key] = `${handleNaN(data[current_B_value] / current_total_B_value * 100).toFixed(1)}%`
          } else if (item.key === 'C_percentage') {
            table_classified_data[table_key][item.key] = `${handleNaN(data[current_C_value] / current_total_C_value * 100).toFixed(1)}%`
          } else if (item.key !== 'count' && item.key !== 'total_number') {
            table_classified_data[table_key][item.key] = data[current_key];
            table_classified_data[table_key].total_number += data[current_key];
          }
        });
      })

      this.data.table_data = Object.values(table_classified_data);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/memberExclusionPaycount.vue